export enum consultRefundEnum {
	PROTOCOLNUMBER = 'protocolNumber',
}

export enum refundModalityEnum {
	CONSULTA = 'CONSULTA',
}
